import React from 'react';
import {useTranslation} from 'react-i18next';
import {animated} from 'react-spring';

import {useMeasure} from '@edna/components/utils';

import {EChannelType} from 'src/constants';
import {useAppearStyles} from 'src/hooks';

import {TAvailableTariff} from '../definitions';
import {LicensePricing, SmsPricing, ViberPricing, WhatsAppPricing} from './ChannelPricing';
import * as S from './style';

export const TariffPricing = React.memo<{
  tariff: TAvailableTariff & {id?: number};
  subjectId?: number;
}>(({subjectId, tariff}) => {
  const {t} = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const [childrenRef, {height: childrenHeight}] = useMeasure<HTMLDivElement>();

  const styles = useAppearStyles({
    isVisible,
    childrenHeight,
    onClose: () => setIsOpen(false),
  });

  const handleOpen = () => {
    setIsOpen(true);
    setIsVisible((previous) => !previous);
  };

  return (
    <S.Container>
      <S.More onClick={handleOpen}>
        <S.MoreLabel>{t('Tariffs:tariffCard.pricing')}</S.MoreLabel>
        <S.MoreIcon isOpen={isVisible} />
      </S.More>
      {isOpen && (
        <animated.div style={styles}>
          <S.Container ref={childrenRef}>
            {tariff?.channelType === EChannelType.SMS && (
              <SmsPricing subjectId={subjectId} tariff={tariff} />
            )}
            {tariff?.channelType === EChannelType.WHATSAPP && (
              <WhatsAppPricing subjectId={subjectId} tariff={tariff} />
            )}
            {tariff?.channelType === EChannelType.VIBER && (
              <ViberPricing subjectId={subjectId} tariff={tariff} />
            )}
            {tariff?.channelType &&
              [EChannelType.MAX, EChannelType.MAX_BOT, EChannelType.TELEGRAM].includes(
                tariff.channelType,
              ) && <LicensePricing tariff={tariff} />}
          </S.Container>
        </animated.div>
      )}
    </S.Container>
  );
});

TariffPricing.displayName = 'TariffPricing';
